export default __webpack_public_path__ + "static/1-start-screen-2fea34c630f9956adf81fc56bfbdd7fc.jpg";